const store = {
  namespaced: true,
  state: {
    keepAlive: [],
  },

  mutations: {
    SET_KEEP_ALIVE: (state, keepAlive) => {
      state.keepAlive = keepAlive;
    },
  },
};

export default store;
